import { BRAND_VIEW_SECTION_TYPES } from 'homepage/enums/contentConstants';

export const filterSections = (sections, isMobile) => {
  const viewportSections = [];

  for (const section of sections) {
    if (section?.type === BRAND_VIEW_SECTION_TYPES.VIDEO_HERO_SECTION) {
      const asset = section?.videos?.[0];
      const { aspect } = asset;
      const isPortrait = aspect < 1;

      if (isPortrait && isMobile) {
        viewportSections.push(section);
      }

      if (!isPortrait && !isMobile) {
        viewportSections.push(section);
      }
    } else {
      viewportSections.push(section);
    }
  }

  return viewportSections;
};
